import { render } from "./verification-challenge.vue?vue&type=template&id=77f3a343"
import script from "./verification-challenge.vue?vue&type=script&lang=js"
export * from "./verification-challenge.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__